import React from 'react'
import styles from './Details.module.css'

const ZARPayment = () => {
  return (
    <div className={styles.wrapper}>
        {/* TODO: It will be nice to show a different copy when user is redirected and the come back to same page */}
        <h1>Payment in progress</h1>
        <p>Please note that you will be redirected to a third-party provider</p>
        <p>to complete your payment...</p>
    </div>
  )
}

export default ZARPayment